import React from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import '../styles/NotFound.css';

function NotFound() {
  return (
    <div className="not-found-page">
      <Navigation />
      <div className="not-found-content">
        <h2>404</h2>
        <h1>Page Not Found</h1>
        <p>The specified page was not found on this website. Please check the URL for mistakes and try again.</p>
        <h3>Why am I seeing this?</h3>
        <p>This page doesn't exist in our application. You may want to visit the <a href="/">home page</a> instead.</p>
      </div>
      <Footer />
    </div>
  );
}

export default NotFound;
